export default __webpack_public_path__ + "static/media/7.9596e12f.jpg";